import InvitationModalContainer from './invitation_modal_container';

const InvitationModal = InvitationModalContainer;
export default InvitationModal;
